import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LinkTypeMode } from '../../../types';
import { utils } from '../../../services';
import { Icon, Button } from 'antd';
import { language } from '../../../language';

/**
 * 图文广告位，广告填充项组件列表
 */

interface IProps {
    tabList: any;
    tabIndex: number;
    form: any;
    maxCount: number;
    onChange?: (value: any) => void;
    onChangeItem?: (value: any, index: number) => void;
    linkTypes: Array<any>;
    linkTypeMode?: LinkTypeMode;
    renderItem: any;
}

export class EntryList extends PureComponent<IProps> {
    static propTypes = {
        maxCount: PropTypes.number,
        onChange: PropTypes.func,
    };

    state = { tabList: cloneDeep(this.props.tabList) };

    // 拖拽结束
    handleDragEnd = (result) => {
        if (!result.destination) return;
        const newTabList = cloneDeep(this.state.tabList);
        const { onChangeItem, tabIndex } = this.props;
        const startIndex = result.source.index;
        const endIndex = result.destination.index;

        newTabList[tabIndex].imgList.splice(
            endIndex,
            0,
            newTabList[tabIndex].imgList.splice(startIndex, 1)[0]
        );

        this.setState({ tabList: newTabList }, () => onChangeItem(this.state.tabList, tabIndex));
    };

    // 修改项
    handleChangeItem = ({ item, type }, index) => {
        const { tabIndex, onChangeItem } = this.props;
        const newTabList = cloneDeep(this.state.tabList);

        if (type === 'add') {
            newTabList[tabIndex].imgList[index] = {
                ...newTabList[tabIndex].imgList[index],
                ...item,
            };
        } else {
            newTabList[tabIndex].imgList.splice(index, 1);
        }

        this.setState({ tabList: newTabList }, () => onChangeItem(this.state.tabList, tabIndex));
    };

    // 点击添加广告位
    handleCilckAdd = (props) => {
        const { tabIndex, onChangeItem } = props;
        const newTabList = cloneDeep(this.state.tabList);
        newTabList[tabIndex].imgList.push({ uuid: utils.uuid() });

        this.setState({ tabList: newTabList }, () => onChangeItem(this.state.tabList, tabIndex));
    };

    // 渲染项
    renderItem = (item, index, isDragDisabled) => {
        const { linkTypes, linkTypeMode, renderItem, onChange } = this.props;
        const itemContent = React.createElement(renderItem, {
            linkTypes,
            linkTypeMode,
            item,
            onChange,
            onChangeItem: (e) => this.handleChangeItem(e, index),
        });

        return (
            <Draggable
                // key={`${item.uuid || index}`} 会导致拖动几次后拖动不了
                key={index}
                isDragDisabled={isDragDisabled}
                draggableId={'drag-' + index}
                index={index}
            >
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        {itemContent}
                    </div>
                )}
            </Draggable>
        );
    };

    // 渲染创建项
    renderCreateItem = () => {
        const { tabIndex, maxCount } = this.props;
        const item = this.state.tabList[tabIndex];
        if (item.imgList.length >= maxCount) return undefined;

        return (
            <div className="entry-item item-create">
                <p>
                    <Button type={'link'} onClick={() => this.handleCilckAdd(this.props)}>
                        <Icon type="plus" /> {language.getText('components.ImageAd.addImage')}
                    </Button>
                </p>
                <p>{language.getText('components.ImageAd.imageSize')}</p>
            </div>
        );
    };

    // 渲染拖拽列表
    renderItems = () => {
        const { tabIndex, tabList } = this.props;
        const item = tabList[tabIndex];
        const isDragDropDisabled = item.imgList.length === 1;

        return (
            <DragDropContext onDragEnd={this.handleDragEnd} key={tabIndex}>
                <Droppable
                    isDropDisabled={isDragDropDisabled}
                    droppableId={`cm-editor-list${tabIndex}`}
                    direction="vertical"
                >
                    {(provided) => [
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {item.imgList.map((imgItem, imgIndex) =>
                                this.renderItem(imgItem, imgIndex, isDragDropDisabled)
                            )}
                        </div>,
                        provided.placeholder,
                    ]}
                </Droppable>
            </DragDropContext>
        );
    };

    render() {
        return <div className="entry-list">{[this.renderItems(), this.renderCreateItem()]}</div>;
    }
}
